export const MODAL_TYPE_DELETE_COMMENT = 'delete-comment';
